<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.fusername"
            placeholder="代理商名称"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item
        >
          <el-input
                  v-model="searchForm.userName"
                  placeholder="商户名"
                  style="width: 100px;"
          />
        </el-form-item>

        <el-form-item
        >
          <el-input
                  v-model="searchForm.legal"
                  placeholder="联系人"
                  style="width: 100px;"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button  v-if="is_dl_type=='-1' && is_ygs=='0'"  @click="openViewForm()">
           服务商支付参数
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="商户名"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>



      <el-table-column
        label="商户账号"
        prop="userCode"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.userCode}}
        </template>
      </el-table-column>
      <el-table-column
              label="联系人"
              prop="legal"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.legal}}
        </template>
      </el-table-column>
      <el-table-column
              label="签约状态"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.pass=='0'">
            已签约
          </div>
          <div v-else-if="scope.row.pass=='1'  || scope.row.pass=='3'">
            未开通
          </div>
          <div v-else-if="scope.row.pass=='2'">
            待审核
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="上级代理"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.pagentid}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="300"
      >
          <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">支付配置</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :agent="agent"
      :accuseVisible="accuseVisible"
      v-model="editFormVisible"
      @submit="getTableData"
    />

    <view-form
            v-model="viewFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm"
import viewForm from "./viewForm"
import util from '@/libs/util.js'
export default {
  name: "PayparameterPage",
  components: { editForm,viewForm },
  data() {
    return {
      searchForm: {
          userName: "",
          userCode: ""
      },
        is_dl_type:'',
        is_ygs:util.cookies.get('is_ygs'),
        accuseVisible:true,
      loading: false,
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        agent: {},
      editFormVisible: false,
        viewFormVisible: false
    };
  },
  mounted() {
      if(util.cookies.get('dl_type')!=null || util.cookies.get('dl_type')!=""){
          console.info("dl_type========"+util.cookies.get('dl_type'))
          this.is_dl_type=util.cookies.get('dl_type');
      }
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          dl_type: util.cookies.get('dl_type'),
          xt_id:util.cookies.get('xt_id'),
          dl_type2:'4',
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getAgentPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(agent) {
          this.agent = agent;
          this.editFormVisible = true;
        this.accuseVisible=true;
      },
      openViewForm(agent) {
          this.agent = agent;
          this.editFormVisible = false;
          this.accuseVisible=false;
          this.viewFormVisible = true;
      },
    add() {
      this.agent = {};
      this.editFormVisible = true;
        this.accuseVisible=true;
    },
    reset(userId) {
        let msg = "重置密码";
        this.$confirm("确定要重置该帐号的密码吗？！重置后的密码为123456", "确认信息", {
            distinguishCancelAndClose: true,
            confirmButtonText: msg,
            cancelButtonText: "取消"
        }).then(() => {
            agentService.resetAgent({userId:userId}).then(() => {
                this.getTableData();
            });
        });
    },
    del(agentid,type) {
        let msg = type == 1 ? "禁用" : "启用";
      this.$confirm("确认"+msg+"操作？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delAgent({agentid:agentid,type:type}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
